import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState, useContext, useEffect, useRef } from "react";
import UseAxios from "../Cust_Hook/UseAxios";
import { QuizContext } from "../Context/QuizContext";
import { useNavigate } from "react-router-dom";
import { decode } from "html-entities";
import { useQuiz } from "../Context/QuizContext";
import './Result.css'


const randomInt = (max) => {
  return Math.floor(Math.random() * Math.floor(max));
};

const Ques_box = () => {
  const [score, setScores] = useState(0);
  const { setScore } = useQuiz();
  const { quizData } = useContext(QuizContext);
  const navigate = useNavigate();
  const { category, difficulty, type, amount } = quizData;

  let apiUrl = `/api.php?amount=${amount}`;

  if (category) {
    apiUrl = apiUrl.concat(`&category=${category}`);
  }
  if (difficulty) {
    apiUrl = apiUrl.concat(`&difficulty=${difficulty}`);
  }
  if (type) {
    apiUrl = apiUrl.concat(`&type=${type}`);
  }

  const { res, loading, err } = UseAxios({ url: apiUrl });
  const [questionIndex, setQuestionIndex] = useState(0);
  const [option, setOption] = useState([]);
  const [timeLeft, setTimeLeft] = useState(10);
  const timerRef = useRef(null);


  useEffect(() => {
    if (res?.results.length) {
      const question = res.results[questionIndex];
      let answers = [...question.incorrect_answers];
      answers.splice(
        randomInt(question.incorrect_answers.length),
        0,
        question.correct_answer
      );
      setOption(answers);
      setTimeLeft(10);
      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 2*1000);
    }
  }, [res, questionIndex]);

  useEffect(() => {
    // When timeLeft reaches 0, go to the next question
    if (timeLeft === 0) {
      clearInterval(timerRef.current);
      if (questionIndex + 1 < res.results.length) {
        setQuestionIndex(questionIndex + 1);
      } else {
        navigate("/Result");
      }
    }
  }, [timeLeft]);

  if (loading) {
    return (
      <Box mt={20} mb={20} textAlign="center">
        <CircularProgress />
      </Box>
    );
  }
  if (err) {
    return (
      <Typography variant="h4" mt={20} color="red" mb={20} textAlign="center">
        Some Want Wrong
      </Typography>
    );
  }

  const handleClickAnswer = (e) => {
    const question = res.results[questionIndex];
    if (e.target.textContent === question.correct_answer) {
      setScores(score + 1);
      setScore(score);
    }
    if (questionIndex + 1 < res.results.length) {
      setQuestionIndex(questionIndex + 1);
    } else {
      navigate("/Result");
    }
  };

  return (
    <Paper
        sx={{
          p: "1rem",
          md: "1rem",
          borderRadius: "10px",
          marginBottom: "1rem",
          maxHeight: "400px"
        }}
      >
    <Container maxWidth="sm">
      <Box textAlign="center">
        <Typography variant="h4" fontFamily='Kanit'>Question {questionIndex + 1}</Typography>
        {res.results && (
          <>
          <Box mt={3}>
          <LinearProgress
            variant="determinate"
            value={(timeLeft / 10) * 100}
            color="secondary"
          />
        </Box>
        {/* <Typography variant="body2" fontFamily='Montserrat' mt={1}>
          Time left: {timeLeft} seconds
        </Typography> */}
          <Typography mt={3} variant="h5" fontFamily='Montserrat'>
            {decode(res.results[questionIndex].question)}
          </Typography>
          </>
        )}

        <Grid container spacing={2} sx={{ marginTop: "20px" }}>
          {option.map((data, id) => {
            return (
              <Grid item xs={6} key={id}>
                <Button
                  variant="contained"
                  onClick={handleClickAnswer}
                  style={{ width: "70%", height: "45px" }}
                >
                  {decode(data)}
                </Button>
              </Grid>
            );
          })}
        </Grid>
        <Box mt={5} mb={5}>
          <Typography style={{ fontWeight: 'bold' }} fontFamily='Josefin Sans'>
            Score : {score} / {res.results.length}
          </Typography>
        </Box>
      </Box>
    </Container>
    </Paper>
  );
};

export default Ques_box;
